import { useEffect, useState } from "react";

const useAgendaNavigation = (maxIndex: number, agendaIndex?: number | null, initialShowArchived = false ) => {

  const [selectedAgendaIndex, setSelectedAgendaIndex] = useState<number>(
  typeof agendaIndex === 'number' && agendaIndex >= 0 ? agendaIndex : 0
);

// Sync selectedAgendaIndex when agendaIndex changes
useEffect(() => {
  if (typeof agendaIndex === 'number' && agendaIndex >= 0) {
    setSelectedAgendaIndex(agendaIndex);
  } else {
    setSelectedAgendaIndex(0);
  }
}, [agendaIndex]);
  const [showArchived, setShowArchived] = useState(initialShowArchived)
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(maxIndex > 0 ? 'panel0' : false);

  const toggleArchived = () => {
    setShowArchived(!showArchived);
    setSelectedAgendaIndex(0);
    setExpandedAccordion(false);
  };

  const createGoToNextAgenda = (maxIndex: number) => () => {
    if (selectedAgendaIndex < maxIndex - 1) {
      setSelectedAgendaIndex(selectedAgendaIndex + 1);
    }
  };

  const goToNextAccordion = (currentIndex: number, totalCount: number) => {
    const nextIndex = currentIndex + 1;
    if (nextIndex < totalCount) {
      setExpandedAccordion(`panel${nextIndex}`);
    }
  };
  useEffect(() => {
    setExpandedAccordion(maxIndex > 0 ? 'panel0' : false)
  }, [maxIndex])
  useEffect(() => {
    setShowArchived(initialShowArchived)
  },[initialShowArchived])
  return {
    selectedAgendaIndex,
    setSelectedAgendaIndex,
    showArchived,
    expandedAccordion,
    setExpandedAccordion,
    toggleArchived,
    createGoToNextAgenda,
    goToNextAccordion
  };
};

export default useAgendaNavigation;